import Button from '@components/Button';
import Checkbox from '@components/Checkbox';
import Column from '@components/Column';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

/**
 * 회원탈퇴 버튼
 * @constructor
 */
function TerminationFooter() {
    const { t } = useTranslation('accountTermination');
    return (
        <Column fullWidth>
            <CheckboxWrapper>
                <Checkbox isChecked >
                    {t('footer.checkbox')}
                </Checkbox>
            </CheckboxWrapper>
            <ButtonWrapper>
                <Button fullWidth >
                    {t('footer.button')}
                </Button>
            </ButtonWrapper>
        </Column>
    );
}

const CheckboxWrapper = styled.div`
    padding: 12px 0;
    width: 100%;
`;

const ButtonWrapper = styled.div`
    padding: 20px 0;
    width: 100%;
`;

export default TerminationFooter;
